<template>
      <div class="vtu-account-view">
        <navigation-tabs />
        <navigation ref="navigation" />
        <header-section 
            :title="content.title"
            :subtitle="content.description"
        />
        <vtu-simulator-account
            class="vtu--account"
            :type="'vtu--account'"
            :title="content.simulator.title"
            :subtitle="content.simulator.subTitle"
            :infoField="content.simulator.infoField"
            :warningField="content.simulator.warningField"
            :tooltip="content.simulator.tooltip"
            :info="content.simulator.info"
            :questions="content.simulator.questions"
        />
        <footer-section/>
    </div>
</template>

<script>

// Webgl
import WebglManager from '@/glxp/webglManager'

// Mixins
import ViewMixin from "@/mixins/viewMixin"

// Components
import NavigationTabs from '@/components/global/NavigationTabs.vue'
import Navigation from "@/components/global/navigation"
import Header from "@/components/global/header"
import Footer from "@/components/global/footer"
import vtuSimulatorAccount from "@/components/vtu/vtu-simulator-account"

export default {
    name: 'vtu-account',
    mixins: [ViewMixin],
    data: ()=>{
        return {
            visible: true,
        }
    },
    components: {
        'navigation-tabs':NavigationTabs,
        'navigation': Navigation,
        'header-section': Header,
        'footer-section': Footer,
        'vtu-simulator-account': vtuSimulatorAccount
    },
    
    beforeMount() {
        this.content = this.$store.state.page["vtu-account"].data.attributes
    },
    mounted () {  
        
        this.$nextTick(()=>{
            this.glxp = WebglManager.getScene('main')
            WebglManager.loadScene('main').then(()=>{
                WebglManager.activate('main')
                this.glxp.skipIntro()
                this.show()
            })
        })
    },
    beforeDestroy () {
        this.$refs.navigation.forcedLight = false
        },
        
    methods: {
        show(){
            this.$refs.navigation.hidden = false
            this.$refs.navigation.forcedLight = true
        },
    },
}
</script>

<style lang="less" >
@import "../styles/vars.less";

.vtu--account{
    background: @sky-blue;
    
    .form.vtu-simulator-grid-item{
        background: @sky-blue;
    }
}

</style>